import { CreateAttributeRequest, CUSTOM_ATTRIBUTE_ROUTES } from "@zeal/common";
import { IAxiosInstance } from "../../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../../AbstractApiClient/IApiResponse";

export const createAttribute = (axios: IAxiosInstance) => {
  return async (data: CreateAttributeRequest) => {
    const response = await axios.noRetry.put<IApiResponse<any>>(
      CUSTOM_ATTRIBUTE_ROUTES.CREATE_ATTRIBUTE,
      data
    );

    const resData = response.data;

    if (resData.success) {
      return resData.data;
    }

    throw new Error("Something went wrong");
  };
};
